import { createFileRoute } from '@tanstack/react-router';
import { AddShipment } from '@uturn/portal/modules/shipments';

export const Route = createFileRoute('/_protected/shipments/add/')({
	component: AddShipment,
});
